export const PROFILE_ROLE = {
    CUSTOMER: "Customer",
    AGENT: "Agent",
    ADMIN: "Admin",
}
  
